import React, { useState } from 'react';

function OfferForm({ request, onClose, onSuccess, userTelegramId }) {
  const [price, setPrice] = useState('');
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL || '/api';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(API_URL + '/offers', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify({
          request_id: request.id,
          executor_id: userTelegramId,
          customer_id: request.user_id,
          price: parseFloat(price),
          comment: comment,
          status: 'pending'
        })
      });

      if (response.ok) {
        onSuccess();
      } else {
        const error = await response.json();
        alert(error.error || 'Ошибка отправки предложения');
      }
    } catch (error) {
      alert('Ошибка соединения');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div 
        className="bg-industrial-bg2 rounded-2xl max-w-md w-full border border-slate-700 shadow-large"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Заголовок */}
        <div className="p-6 border-b border-slate-700">
          <h2 className="text-xl font-black text-white m-0 uppercase tracking-tight">
            💰 Предложить цену
          </h2>
        </div>

        {/* Форма */}
        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-4">
            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wide mb-2">
              Заявка
            </label>
            <div className="px-4 py-3 bg-industrial-bg rounded-xl text-slate-200 font-medium">
              {request.type_id === 1 ? 'Ищу технику' : 'Сдаю технику'} #{request.id}
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wide mb-2">
              Ваша цена (₽)
            </label>
            <input
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              placeholder="Например: 15000"
              required
              min="0"
              className="w-full"
            />
          </div>

          <div className="mb-6">
            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wide mb-2">
              Комментарий к предложению
            </label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Укажите условия, сроки и т.д."
              rows="3"
              className="w-full"
            />
          </div>

          <div className="flex gap-3">
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary flex-1"
            >
              {loading ? 'Отправка...' : '📤 Отправить'}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="btn btn-outline flex-1"
            >
              Отмена
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default OfferForm;
